// extracted by mini-css-extract-plugin
export default {"button":"AdminMobileTabbtnBox_button__DlIsQ","selected":"AdminMobileTabbtnBox_selected__rLFHm"};